<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [showBack]="true"></prox-main>
<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <p-button [disabled]="!canAddProgram" size="small" (onClick)="onAdd()" label="Add Program"
      icon="pi pi-plus"></p-button>
    <span *ngIf="isGlobalAdmin" class="qb-status-message">Principal Account Administrator access is required</span>
  </div>
  <div *ngIf="isPageReady" class="flex items-center mb-2">
    <p-checkbox [(ngModel)]="includeExpiredAndInactive" [binary]="true" name="incExpiredInactive"
      inputId="incExpiredInactive" (onChange)="includeExpiredAndInactiveClicked()"></p-checkbox>
    <label for="incExpiredInactive" class="ml-2">Show expired and inactive?</label>
  </div>
  <div class="qb-layout-grid w-full" *ngIf="isPageReady">
    <prox-ag-grid gridId="programsGrid" [gridOptions]="progGridOptions" [rowData]="programs"></prox-ag-grid>
  </div>
</ng-template>